import HelpIcon from '@mui/icons-material/Help';

import { Button, Hidden, Link } from '@mui/material';
import { httpsUrlTrailingSlash } from 'config/url';
import { useToggle } from '@alluradirect/react';
import { PageHeaderHelpDialog } from 'components/layout/Page/components/PageHeaderHelpDialog';
import { PageHeaderLayout, PageHeaderLayoutProps } from 'components/layout/Page/components/PageHeaderLayout';
import styled from 'styled-components';
import { IS_DIRECT_VACATIONS } from 'config/envSetup';
import { logoAlluraDirect } from 'config/imageUrls';

const StyledLink = styled(Link) <{ $disabled: boolean }>`
  ${props => props.$disabled && `pointer-events: none;`}
`;

export const PageHeader = (headerProps: Omit<PageHeaderLayoutProps, 'children'>) => {
  const helpToggle = useToggle();

  const logo = IS_DIRECT_VACATIONS() ? headerProps.dvLogoFilepath : logoAlluraDirect;
  return (
    <>
      <PageHeaderLayout {...headerProps}>
        <StyledLink href={httpsUrlTrailingSlash()} $disabled={Boolean(headerProps.disabled)}>
          <img src={logo} height={'48px'} style={{ marginTop: '8px' }} />
        </StyledLink>
        {headerProps.logoOnly ? null : (
          <Hidden smDown>
            <Button
              sx={{ color: 'grey.800' }}
              variant="text"
              color="secondary"
              size="large"
              startIcon={<HelpIcon />}
              onClick={helpToggle.open}
            />
          </Hidden>
        )}
      </PageHeaderLayout>

      {helpToggle.isOpen ? <PageHeaderHelpDialog isOpen={helpToggle.isOpen} close={helpToggle.close} /> : null}
    </>
  );
};
